var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',_vm._g(_vm._b({attrs:{"placeholder":"标签","options":_vm.tagOptionsTree,"props":{
    multiple: true,
    children: 'childrenList',
    value: 'id',
    label: 'text',
    emitPath: false
  },"size":"small","collapse-tags":"","show-all-levels":false},on:{"visible-change":_vm.tagOptionsChange}},'el-cascader',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }